const icon = "/_app/immutable/assets/icon.C-rl1jZn.png";
export {
  icon as default
};
